import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import { compose, withHandlers, withState } from 'recompose';
import { withAppContext } from '@ctsu/loader';
import { openConfirmation } from 'helpers/Confirmation';
import _ from 'lodash';
import { ValidatorForm } from 'components/FormHelpers/FormInputs';
import { GetFromCtxValue, GetUserFullName, useGetPathProtocol } from 'helpers';
import { CanUserDeleteAgentsDevice, CanUserEditAgentsDevice } from 'appconstants/Permission';
import { httpStatusEnum , TE } from 'appconstants';
import EditIDEAgents from './EditIDEAgents';
import { IDEAgentcolumns } from '../gridcolumns';

let setEditingIdeFlag;
const IdeAgents = ({
  data,
  saveIDEAgentInfo,
  agentValue,
  setState,
  state,
  cancelAgent,
  rowDeletable
}) => {
  const RenderEditRow = (row, setEditing) => {
    if (_.isEmpty(state) && !_.isEqual(row, state)) {
      setState({ ...row });
    }
    setEditingIdeFlag = (flg) => {
      setEditing(flg);
      setState({});
    };

    return (
      <EditIDEAgents
        state={state || row}
        defaultRow={row}
        setEditing={setEditing}
        agentType={agentValue}
        setState={setState}
      />
    );
  };

  const onDelete = (row) => {
    cancelAgent(row.csaId, row.indIdeType === 'IDE' ? row.indIdeType : 'IDE_EXEMPT');
  };

  const saveIdeAgents = () => {
    saveIDEAgentInfo(state);
  };

  return (
    <ValidatorForm onSubmit={saveIdeAgents}>
      <GridTable
        tag={`${TE.ID}idestudyagents${TE.TABLE}`}
        title="IDE Study Agents"
        exportTitle={`IDE Study Agents-${useGetPathProtocol()}-Study Agents`}
        id="ideAgents"
        columns={IDEAgentcolumns}
        user={GetUserFullName()}
        rows={data}
        editable
        editMode={CanUserEditAgentsDevice()}
        deletable={CanUserDeleteAgentsDevice()}
        allowAddRow
        filterable
        sortable
        onDelete={onDelete}
        enableToolbar
        renderEditRow={RenderEditRow}
        rowEditable={() => true}
        rowDeletable={() => true}
        recordPerPage={10}
        toPdf={false}
      />
    </ValidatorForm>
  );
};
const IDEAgents = compose(
  withAppContext,
  withState('state', 'setState', {}),
  withHandlers({
    saveIDEAgentInfo: props => postBody => {
      const {
        onSave, protocolId, agentLabel, context
      } = props;
      const confirmSave = () => {
        const postInfo = {
          ...postBody,
          esysStatus: postBody.esysStatus || 'ACTIVE',
          indIdeType: agentLabel,
          prtId: protocolId
        };
        onSave(postInfo).subscribe(resp => {
          if (resp.status === httpStatusEnum.SUCCESS) {
            setEditingIdeFlag(false);
          }
        });
      };
      openConfirmation({
        message: GetFromCtxValue(context, 'SAVE_IDE_INFO_CONFIRM_TXT'),
        onAction: confirmSave,
        name: 'save_ide'
      });
    }
  })
)(IdeAgents);

export default IDEAgents;
